import * as UserAction from '@ori-events/user-action';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import { useCallback } from 'react';

import { CLICK_CATALOGUE_DETAIL } from '../../../constants';
import { useCatalogues } from '../../../context';
import { useShopSection } from '../../../context/navigation';
import { useIsMobile } from '../../../hooks';
import { formatValidity } from '../../../utils/formatValidity';
import { SkeletonCatalogueDesktop, SkeletonCatalogueMobile } from '../../Skeleton';
import { CurrentCatalogue } from './CurrentCatalogue';
import { NextCatalogue } from './NextCatalogue';
import { Root } from './styles';

export const Catalogues: FC = () => {
  const { catalogues, isLoading } = useCatalogues();
  const { items } = useShopSection();
  const isMobile = useIsMobile();
  const { getTestId } = useTestId();

  const sendAnalyticsData = useCallback(() => {
    UserAction.dispatch(CLICK_CATALOGUE_DETAIL);
  }, []);

  if (isLoading) {
    return isMobile ? <SkeletonCatalogueMobile /> : <SkeletonCatalogueDesktop />;
  }

  if (items.length === 0) {
    return null;
  }

  const link = items.find((e) => e.linkType === 'Catalogue');
  const catalogueCurrent = link?.children.find((e) => e.linkType === 'DigitalCatalogueCurrent');
  const catalogueNext = link?.children.find((e) => e.linkType === 'DigitalCatalogueNext');
  const isCatalogueNextValid = Boolean(
    !isMobile && catalogueNext?.id && catalogueNext.imageUrl && catalogueNext.title && catalogueNext.url,
  );
  const linkToAllCatalogues = link?.children.find((e) => e.linkType === 'Catalogues');

  if (!catalogueCurrent?.id || !catalogueCurrent.imageUrl || !catalogueCurrent.title || !catalogueCurrent.url) {
    return null;
  }

  return (
    <Root
      isMobile={isMobile}
      data-testid={getTestId('catalogues-root')}
    >
      <CurrentCatalogue
        catalogue={{ ...catalogueCurrent, validity: formatValidity(catalogueCurrent.id, catalogues) }}
        isMobile={isMobile}
        linkToAllCatalogues={linkToAllCatalogues?.url ?? ''}
        onClick={sendAnalyticsData}
      />

      {isCatalogueNextValid && catalogueNext ? (
        <NextCatalogue
          catalogue={{ ...catalogueNext, validity: formatValidity(catalogueNext.id ?? '', catalogues) }}
          onClick={sendAnalyticsData}
        />
      ) : null}
    </Root>
  );
};
